import { render, staticRenderFns } from "./customRegion.vue?vue&type=template&id=161ad32a&scoped=true&"
import script from "./customRegion.vue?vue&type=script&lang=js&"
export * from "./customRegion.vue?vue&type=script&lang=js&"
import style0 from "./customRegion.vue?vue&type=style&index=0&id=161ad32a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161ad32a",
  null
  
)

export default component.exports